import styled from 'styled-components';

export const HoverWrapper = styled.div`
  &:hover {
    .hover-item {
      opacity: 1;
    }
  }
`;

export const HoverItem = styled.div.attrs({
  className: 'hover-item',
})`
  transition: opacity 0.2s;
  opacity: 0;
`;
